import React from "react";
import { TabController } from "./TabController";
import Debtor from "./Debtor";
import { DebtorTabType } from "../Types";

/**
 * @description - Tab container for debtor result view.
 * @author Tharanga Niroshana <tharangan@unicorn-solutions.com>
 * @since 12/01/2025
 * */
export const DebtorTab: React.FC<DebtorTabType> = (props) => {
  const {
    debtorData,
    tabInfo,
    isLoading,
    currentHit,
    paginationChangeEvent,
    totalDebtorSearchResult,
    aRClickEvent,
    changeSortOrderEvent,
  } = props;

  return (
    <TabController
      isLoading={isLoading}
      changeSortOrderEvent={changeSortOrderEvent}
      tabInfo={tabInfo}
    >
      <Debtor
        currentHit={currentHit}
        paginationChangeEvent={paginationChangeEvent}
        debtorData={debtorData}
        aRClickEvent={aRClickEvent}
        totalSearchResult={totalDebtorSearchResult}
      ></Debtor>
    </TabController>
  );
};
